import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@app/@core/guards/auth.guard';
import { BlankLayoutComponent, OneColumnLayoutComponent } from '@app/@theme/layouts';
import { NotFoundComponent } from '@app/shared/pages/not-found/not-found.component';

const routes: Routes = [
  {
    path: 'auth-callback',
    component: BlankLayoutComponent,
    loadChildren: './pages/auth-callback/auth-callback.module#AuthCallbackModule',
  },
  {
    path: '',
    component: OneColumnLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: './pages/pages.module#PagesModule',
  },
  {
    path: 'login',
    redirectTo: ''
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
